import type { SVGProps } from 'react';

export const SvgIconCategory240 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={33} height={33} viewBox="0 0 33 33" fill="none" {...props}>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.625 12.884h26l-13-8zM7.625 12.884v10M13.625 12.884v10M19.625 12.884v10M25.625 12.884v10M4.625 22.884h24M2.625 26.884h28"
    />
  </svg>
);
